import { Component } from '@angular/core';
import { DealViewOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/deal-view/deal-view-wrapper.component';

@Component({
  selector: 'app-deal-view-mobile',
  templateUrl: './deals-view-mobile.component.html',
  styleUrls: ['./deals-view-mobile.component.scss'],
})
export class DealViewMobileComponent extends DealViewOpenQuoteWrapper {
}
